import { createFileRoute } from '@tanstack/react-router';

import { ExternalSupplierOverview } from '~/components/dataExchanges/ExternalSupplierOverview';

export const Route = createFileRoute('/(custom)/external-supplier')({
  component: ExternalSupplierOverview,
});
